import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 90000 });

export const sendChat = (payload) => api.post("/chat", payload).then((r) => r.data);
export const getHistory = (sid) => api.get(`/chat/history/${sid}`).then((r) => r.data);
export const generateStory = (payload) => api.post("/story", payload).then((r) => r.data);
export const generateQuiz = (payload) => api.post("/quiz", payload).then((r) => r.data);
export const generatePath = (payload) => api.post("/learning-path", payload).then((r) => r.data);
export const getTopics = () => api.get("/topics").then((r) => r.data);
export const getCareers = () => api.get("/careers").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const getDAU = () => api.get("/dau").then((r) => r.data);
export const getDailyStory = () => api.get("/daily-story", { timeout: 180000 }).then((r) => r.data);
export const getAchievements = () => api.get("/achievements/catalog").then((r) => r.data);
export const subscribeDigest = (payload) => api.post("/subscribe", payload).then((r) => r.data);
export const unsubscribeDigest = (payload) => api.post("/unsubscribe", payload).then((r) => r.data);
export const getSubscriberStats = () => api.get("/subscribers/stats").then((r) => r.data);
export const sendTodayDigest = () => api.post("/digest/send-today").then((r) => r.data);
export const getCohort = () => api.get("/cohort").then((r) => r.data);
export const getShowcase = () => api.get("/showcase").then((r) => r.data);

const adminHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const adminCheck = (token) => api.post("/admin/check", null, adminHeaders(token)).then((r) => r.data);
export const adminRecent = (token) => api.get("/admin/recent", adminHeaders(token)).then((r) => r.data);
export const adminPreviewTomorrow = (token) => api.post("/admin/preview-tomorrow", null, { ...adminHeaders(token), timeout: 120000 }).then((r) => r.data);
export const adminSendToday = (token) => api.post("/digest/send-today", null, { ...adminHeaders(token), timeout: 120000 }).then((r) => r.data);
export const adminPostTweet = (token) => api.post("/admin/post-today-tweet", null, { ...adminHeaders(token), timeout: 60000 }).then((r) => r.data);
export const getTwitterStats = () => api.get("/twitter/stats").then((r) => r.data);
export const getSharedStory = (id) => api.get(`/share/story/${id}`).then((r) => r.data);
export const getSharedQuiz = (id) => api.get(`/share/quiz/${id}`).then((r) => r.data);
export const illustrateStory = (id) => api.post(`/story/${id}/illustrate`).then((r) => r.data);
export const BACKEND = BACKEND_URL;
